import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-3 gap-4 text-xs" }

import { useContactTimelineFilterStore, useFilterStore } from '@/stores';
import { CallType } from '@/types';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactTimelineFilters',
  setup(__props) {

const { t } = useI18n();

const filterStore = useFilterStore();
const timelineStore = useContactTimelineFilterStore();

const dateRange = computed<Array<Date>>({
    get: () => filterStore.dateRange,
    set: (range) => filterStore.setDateRange(range),
});

const callTypeFilterOptions = [
    { label: t(`call.type.${CallType.INBOUND}`), value: CallType.INBOUND },
    { label: t(`call.type.${CallType.OUTBOUND}`), value: CallType.OUTBOUND },
    { label: t(`call.type.${CallType.INTERNAL}`), value: CallType.INTERNAL },
];

const sentimentFilterOptions = [
    { label: t('contact.filters.sentiment.satisfied'), value: 'satisfied' },
    { label: t('contact.filters.sentiment.neutral'), value: 'neutral' },
    { label: t('contact.filters.sentiment.unsatisfied'), value: 'unsatisfied' },
    { label: t('contact.filters.sentiment.angry'), value: 'angry' },
];

return (_ctx: any,_cache: any) => {
  const _component_UiDatePicker = _resolveComponent("UiDatePicker")!
  const _component_UiMultiselect = _resolveComponent("UiMultiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UiDatePicker, {
      modelValue: dateRange.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dateRange).value = $event)),
      range: "",
      multiCalendars: ""
    }, null, 8, ["modelValue"]),
    _createVNode(_component_UiMultiselect, {
      name: "filters_type",
      modelValue: _unref(timelineStore).callType,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(timelineStore).callType) = $event)),
      options: callTypeFilterOptions,
      placeholder: _unref(t)('contact.filters.allCallTypes'),
      class: "[&_.multiselect]:!h-[36px]",
      "can-clear": ""
    }, null, 8, ["modelValue", "placeholder"]),
    _createVNode(_component_UiMultiselect, {
      name: "filters_sentiment",
      modelValue: _unref(timelineStore).sentiment,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(timelineStore).sentiment) = $event)),
      options: sentimentFilterOptions,
      placeholder: _unref(t)('contact.filters.allSentiments'),
      class: "[&_.multiselect]:!h-[36px]",
      "can-clear": ""
    }, null, 8, ["modelValue", "placeholder"])
  ]))
}
}

})